import ReferencePathService from "~/services/referencePathServices/referencePathService";
import {ModelType} from "~/enums/modelType";
import {IReferencePathNodeCertificateDynamicInput, IReferencePathNodeSpecific} from "~/interfaces/referencePathInterfaces";
import CertificateDynamicInput from "../../../formability/certificateBuilder/models/certificateDynamicInput";
import {GenericType} from "~/interfaces/genericTypeInterfaces";

export default class CertificateDynamicInputPathService extends ReferencePathService {
  imposterModelType: ModelType = ModelType.CertificateDynamicInput;

  constructor(private certificateDynamicInputNode: IReferencePathNodeCertificateDynamicInput) {
    super();
  }

  get label(): string {
    return this.certificateDynamicInputNode.reference()?.name;
  }

  get nodes(): IReferencePathNodeCertificateDynamicInput[] {
    return [this.certificateDynamicInputNode];
  }

  reference(): CertificateDynamicInput {
    return CertificateDynamicInput.repo.findBy((di) => di.id === this.certificateDynamicInputNode.reference_id);
  }

  get referenceGenericModelType(): GenericType {
    return this.reference()?.genericType;
  }

  get referenceModelType(): ModelType {
    return this.reference()?.modelType;
  }

  canLinkTo(node: IReferencePathNodeSpecific): boolean {
    // either end of line or node references contained CertificateDynamicInput
    const decision = !node || this.reference().certificateDynamicInputs.some(i => i.id === node.reference_id);
    this.debugCanLinkTo('CertificateDynamicInputPathService', this.certificateDynamicInputNode, node, decision);
    return decision;
  }

  get referenceIsCollection(): boolean {
    return this.reference().isList;
  }

  get referenceIsAppendable(): boolean {
    return this.reference().isList || this.referenceIsText();
  }

}